module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"header":"Beklager, noe gikk galt under oppsett av enheten.","infoMessage":"Det oppstod en feil og enheten din er ikke tilkoblet ennå. Du kan lukke dette vinduet og prøve igjen!"},"en":{"header":"Sorry, something went wrong when setting up your device.","infoMessage":"An error occured and your device is not yet connected. You may close this window and try again!"}}')
  delete Component.options._Ctor
}
